import React, { useMemo, useRef } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useLayoutEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import updateProfile from "../../api/UpdateProfile";
import { interfaceProfileState } from "../../interface/ProfileInterface";
import { SETUSERDATA } from "../../redux/features/userData";
import LoaderButton from "../Buttons/LoaderButton";
import InputNumber from "../FormFields/InputNumber";
import InputText from "../FormFields/InputText";
import LabelText from "../FormLabels/LabelText";
import { ErrorToast } from "../ToastComponent/ErrorToast";
import { SuccessToast } from "../ToastComponent/SuccessToast";
import { initialmyAccountState, myAccountSchema } from "./MyAccountValidation";
import { setCookie } from "../../utils/helper";
import ShortName from "../../utils/ShortName";
import { $confirmDialog } from "../dialog/confirmDialog";
import CameraIconSvg from "../icons/CameraIconSvg";
import EditIconSvg from "../icons/EditIconSvg";
import DeleteIconSvg from "../icons/DeleteIconSvg";

export default function MyAccount() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const inputRef = useRef<any>(null)
  const [previewUrl, setPreviewUrl] = useState("");
  console.log("previewUrl",previewUrl)
  const [profileImage, setProfileImage] = useState();
  const {
    handleSubmit,
    formState: { errors },
    register,
    setValue,
    // getFieldState,
  } = useForm({
    resolver: yupResolver(myAccountSchema),
    defaultValues: initialmyAccountState,
  });
  const {
    userData: { user },
  }: any = useSelector((state) => state);

  const dispatch = useDispatch();

  useLayoutEffect(() => {
    if (Object.keys(user).length > 0) {
      setValue("mobileNumber", user.phone);
      setValue("first_name", user?.first_name);
      setValue("last_name", user?.last_name);
      setValue("email", user.email);
      setPreviewUrl(`${user?.profile_image?.base_url ?? ""}${user?.profile_image?.attachment_url ?? ""}`);
    }
  }, [user]);
  const onSubmitHandler = async (state: interfaceProfileState) => {
    setLoading(true);

    try {
      const data = await updateProfile({ ...state, profileImage });

      if (data.success) {
        dispatch(SETUSERDATA(data.user_data));
        setCookie('user-data', JSON.stringify(data?.user_data), 7)
        SuccessToast(data?.message);
      } else {
        // ErrorToast(data?.message);
      }
      setLoading(false);
    } catch (error: any) {
      ErrorToast(error?.message);
    }
  };


  const addEditProfile = async () => {
    if (previewUrl) {
      const isReplace = await $confirmDialog(t("profile_picture_action"),'', t("Delete"), t("replace"));
      if(!isReplace){
        setPreviewUrl('');
        return;
      }
      inputRef?.current?.click()
    } else {
      inputRef?.current?.click()
    }


  }

  const returnName = useMemo(() => {
    return ShortName(`${user?.first_name}`)
    // return ShortName(`${user?.first_name} ${user?.last_name}`)
  }, [user])
  return (
    <>
      <form onSubmit={handleSubmit(onSubmitHandler)}>
        <div className="p-3">
          <div className="flex gap-3 items-center md:flex-row flex-col mb-8">
            <div className="relative inline-flex" >
              <div className="w-24 h-24 bg-blue-100 rounded-full flex items-center justify-center font-bold text-xl text-black">
                {previewUrl ? (
                  <img src={previewUrl} alt="Profile Image" className="w-24 h-24 rounded-full" />
                ) : (returnName)}
              </div>
              <label onClick={() => addEditProfile()} htmlFor="avatar-upload" className="absolute bottom-0 right-0 bg-[#34558B] rounded-full p-1.5  cursor-pointer" aria-label="Upload profile picture">
                {previewUrl ? <EditIconSvg /> : <CameraIconSvg />}

                {/* <DeleteIconSvg /> */}

              </label>

              <input
                type="file"
                placeholder={t("Profile.name")}
                ref={inputRef}
                onChange={(e: any) => {
                  setProfileImage(e.target.files[0]);
                  const url = e.target.files[0] ? e.target.files[0] : profileImage;
                  if (url) {
                    setPreviewUrl(URL.createObjectURL(url));
                  }
                }}
                accept="image/*"
                className="hidden"
              />
            </div>
            {/* 
            <div className="profileImage mb-3">
              <div className="addImage">
                <div className="showProfile">
                  <img
                    src={
                      previewUrl ? previewUrl : "/images/profile-user-icon.svg"
                    }
                    alt="Profile Image"
                  />
                </div>
              </div>
            </div>
            <label className="bg-[#030027] text-white px-8 py-2 font-semibold text-[.8em] rounded-[13px] cursor-pointer">
              <input
                type="file"
                placeholder="Name"
                onChange={(e: any) => {
                  setProfileImage(e.target.files[0]);
                  setPreviewUrl(URL.createObjectURL(e.target.files[0]));
                }}
                accept="image/*"
                className="hidden"
              />
              {t("Profile.upload")}
            </label> */}
          </div>

          <div className="formItem">
            <LabelText text={`${t("Profile.firstName")}*`} />
            <InputText
              placeholder={t("Profile.firstName")}
              name="first_name"
              register={register}
              className={
                "text-lg font-bold border-b border-[#D7D7D7] w-full py-3 mb-5"
              }
            />
            <div className="errorField">
              {errors.first_name?.message ? t(errors.first_name?.message) : ""}
            </div>
          </div>
          <div className="formItem">
            <LabelText text={`${t("Profile.lastName")}*`} />
            <InputText
              placeholder={t("Profile.lastName")}
              name="last_name"
              register={register}
              className={
                "text-lg font-bold border-b border-[#D7D7D7] w-full py-3 mb-5"
              }
            />
            <div className="errorField">
              {errors.last_name?.message ? t(errors.last_name?.message) : ""}
            </div>
          </div>
          <div className="formItem read-only">
            <LabelText text={t("Profile.phoneNumber")} />
            <InputNumber
              placeholder="1234567890"
              name="mobileNumber"
              register={register}
              readOnly={true}
            />
            <div className="errorField">
              {errors.mobileNumber?.message
                ? t(errors.mobileNumber?.message)
                : ""}
            </div>
          </div>
          <div className="formItem">
            <LabelText text={t("Profile.email")} />
            <InputText
              placeholder="useremail@gmail.com"
              name="email"
              register={register}
              className={
                "text-lg font-bold border-b border-[#D7D7D7] w-full py-3 mb-5"
              }
            />
            <div className="errorField">{errors.email?.message || ""}</div>
          </div>
        </div>
        <div className="flex md:justify-end gap-3 mt-3 md:static fixed bottom-0 p-2 bg-white w-full">
          <div className="btnAction md:w-auto w-full adress-save">
            {loading ? (
              <LoaderButton />
            ) : (
              <button className="md:w-40 bgBlue text-white text-center rounded-lg p-3 w-full font-bold text-base width-in-mobile" type="submit">
                {t("Profile.save")}
              </button>
            )}
          </div>
        </div>
      </form>
      <ToastContainer style={{ zIndex: "999999999" }} />
    </>
  );
}
